import React, { PropsWithChildren } from 'react'

// types
import { ContextProps } from '../types/types'

// page
import MyPassesPage from '../pages/MyPassesPage/MyPassesPage'

// hooks
import useZodQueryParams from '../hooks/useZodQueryParams'

// utils
import { myPassesPageQuerySchema } from '../utils/zodQuerySchemas'

const MyPassesRoute = (props: PropsWithChildren<ContextProps>) => {
	const [query, setQuery] = useZodQueryParams(myPassesPageQuerySchema)

	return <MyPassesPage {...props} query={query} setQuery={setQuery} />
}

export default MyPassesRoute
